<template>
<!--    <a-divider v-if="textItems.length > 0"></a-divider>-->
    <div id="paper-chat" ref="paperChatRef" style="overflow-y: scroll">
        <paper-ref
                v-if="isDEV"
                :text="testData.answer"
                :refs="testData.reference"
                :handle-search="handleSearch"
                :handle-page="handlePage"
                :handle-minus="handleMinus"
        />
        <div>
            <ul id="dialogue">
                <a-spin :spinning="loadingChatMsg">
                    <template v-for="(item, index) in textItems" :key="index">
                        <li style="text-align: center" v-if="item.add_time">
                            <span class="message-time">{{formatTime(item.add_time)}}</span>
                        </li>
                        <li :class="'group' + item.group">
                            <div v-if="item.question">
                                <div class="gpt-font">
                                    <user-outlined class="icon icon-right"/>
                                    <span class="msg text-right">
                                    <img v-if="item.src" :src="item.src" alt="" style="width: 50%; display: block"/>
                                    {{item.question}}
                                </span>
                                </div>
                                <div style="clear: both"></div>
                            </div>
                            <div v-if="item.answer || item.think" class="li textRight" style="margin-top: 10px">
                                <div class="msg-content">
                                    <a-space align="start">
                                        <div>
                                            <paper-icon/>
                                        </div>
                                        <div>
                                            <div class="think" v-if="item.think">
                                                <div style="background: rgb(245,245,245); border-radius: 10px; padding: 7px 14px;width: fit-content; cursor: pointer">
                                                    <a-space>
                                                        <slack-outlined />
                                                        <span v-if="item.answer">已深度思考</span>
                                                        <span v-else><a-space>思考中 <loading-component/></a-space></span>
                                                        <span @click="()=>item.hideThink = !item.hideThink">
                                                        <up-outlined v-if="item.hideThink"/>
                                                        <down-outlined v-else/>
                                                    </span>
                                                    </a-space>
                                                </div>
                                                <simple-code :data="item.think" v-if="!item.hideThink"/>
                                            </div>
                                            <div v-if="item.answer">
                                                <div :class="'gpt-font answer-box ' + item.tag">
                                                    <!--                                                <simple-code :data="item.answer"/>-->
                                                    <paper-ref :text="item.answer" :refs="item.ref_list"
                                                               :handle-search="handleSearch"
                                                               :handle-page="handlePage"
                                                               :handle-minus="handleMinus"
                                                    />
                                                </div>
                                                <span style="cursor: pointer" v-if="!disabled">
                                                        <copy-outlined @click="()=>copyAnswer(item)"/>
                                                    </span>
                                            </div>
                                        </div>
                                    </a-space>
                                </div>
                            </div>
                        </li>
                    </template>
                </a-spin>
                <template v-if="waiting">
                    <li>
                        <div class="li textRight" style="margin-top: 10px">
                            <div class="msg-content">
                                <a-space>
                                    <paper-icon/>
                                    <div class="answer-box">
                                        <a-space class="gpt-font">
                                            查询中，请稍后 <loading-component/>
                                        </a-space>
                                    </div>
                                </a-space>
                            </div>
                        </div>
                    </li>
                </template>
                <li id="bottom"></li>
            </ul>
            <a-back-top :target="getContainer" :visibilityHeight="300"/>
        </div>
        <div style="text-align: right; padding: 10px 0" v-if="textItems.length > 0">
            <a-space>
                <delete-outlined @click="deleteTextItems"/>
            </a-space>
        </div>
        <div id="submit" class="dialogue-submit">
            <div>
                <span :offset-bottom="0" :target="() => paperChatRef">
                    <!--                        <p class="ai-title"><i>AI</i>聊天</p>-->
                    <a-input
                            id="inputValue"
                            style="font-size: 16px!important;"
                            size="large"
                            auto-size
                            v-model:value="inputValue"
                            placeholder="输入问题提问"
                            @pressEnter="()=>handleSubmit(inputValue)"
                            @input="handleInput"
                            :disabled="disabled"
                    >
                        <template #suffix>
                            <LoadingOutlined v-if="waiting"/>
                            <SendOutlined v-else
                                          @click="()=>handleSubmit(inputValue)"
                                          :disabled="!(chatable && (inputValue.length > 0))"/>
                        </template>

                    </a-input>
                    <p style="font-size: 14px; color: rgba(0,0,0,0.28);padding: 5px">
                        注：每个问题消耗 2 积分，[查看<a href="/account" target="_blank">我的积分</a>]
                    </p>
                </span>
            </div>
        </div>
        <div style="height: 1px;opacity: 0">
            <a-input class="copy" v-model:value="copyText"/>
        </div>


    </div>
</template>

<script>
    import {ref} from 'vue';
    import {isPhone} from "../utils/llm.tools";
    import {BackTop} from 'ant-design-vue';
    import {
        LoadingOutlined, SendOutlined, UserOutlined,
        SlackOutlined, UpOutlined, DownOutlined,
        // CopyOutlined,
        // DeleteOutlined
    } from '@ant-design/icons-vue';
    import SimpleCode from "../components/SimpleCode";
    import PaperIcon from "../components/PaperIcon";
    import LoadingComponent from '../components/LoadingComponent';
    import tooltip from "../directives/tooltip";
    import PaperRef from './PaperRef';
    import {formatTime, copyInputValue, isDEV} from "../utils/request";
    import {get_ref_color} from "../utils/common";
    import {post_biogpt_chat_message} from "../utils/bioinfo.api";

    export default {
        name: "PaperChat",
        props: [
            'chatable',
            'h2', 'tip', 'robotIconName', 'egPrefix', 'egItems', 'promptPrefix', 'prefixItems',
            'postFunc', 'postValues',
            'radioItems', 'initRadioValue', 'radioKey',
            'selectItems', 'initSelectValue', 'selectLabel',
            'stream',
            'chat',
            'textItems1',
            'paper_no',
            'setHeight',
            'handleSearch',
            'handlePage',
            'handleMinus',
            'embedding'
        ],
        directives: {
            tooltip,
        },
        components: {
            'a-back-top': BackTop,
            SimpleCode, LoadingComponent,
            LoadingOutlined, SendOutlined, UserOutlined,
            SlackOutlined, UpOutlined, DownOutlined,
            // CopyOutlined, DeleteOutlined,
            PaperIcon,
            PaperRef,
        },
        setup() {
            const paperChatRef = ref();
            return {
                paperChatRef,
            };
        },
        data(){
            return {
                isDEV,
                testData: {
                    "answer": "PRnet（扰动响应预测网络）的训练过程是一个复杂而系统的流程，主要涉及数据的准备、模型的构建与优化等多个步骤。以下将详细阐述PRnet的训练方法及其关键组成部分。\n\n### 数据准备与划分\n\n在训练PRnet之前，首先需要对数据进行准备。PRnet使用了大规模的高通量筛选（HTS）观察数据，这些数据包括来自175,549种化合物的近一亿个观测数据，以及数千万个单细胞HTS观察数据，这些数据受到188种化合物的影响。为了确保模型的泛化能力和准确性，所有数据集被划分为训练集、验证集和测试集，比例为6:2:2，即60%的数据用于训练，20%用于验证，20%用于测试<a>[3]</a>。\n\n### 模型架构\n\nPRnet的核心在于其独特的编码器-解码器架构，包含三个主要组件：Perturb-adapter、Perturb-encoder和Perturb-decoder。Perturb-adapter的作用是将化学干扰的特征进行适配，Perturb-encoder则负责将这些特征编码成模型可以理解的形式，而Perturb-decoder则将编码后的信息解码为预测的转录响应<a>[5]</a>。这种设计使得PRnet能够灵活地处理不同的化学干扰，并生成相应的转录响应。\n\n### 训练过程\n\nPRnet的训练过程通常包括以下几个步骤：\n\n1. **数据预处理**：在预处理阶段，每个受到化学干扰的转录组数据会被分配一个相同细胞系的未干扰转录组数据。这一过程确保了模型能够学习到化学干扰与转录响应之间的关系<a>[5]</a>。\n\n2. **模型训练**：PRnet使用深度学习算法，特别是神经网络架构，通过反向传播算法不断调整其权重，以最小化预测值与真实值之间的误差。训练过程中，模型会利用化合物的SMILES字符串表示化学结构，并结合相应的剂量信息，通过RDKit工具捕捉化合物的功能拓扑信息，进而生成功能类别<a>[5]</a>。此外，训练中还可能应用数据增强技术，以提高模型的泛化能力和鲁棒性<a>[4]</a>。\n\n3. **超参数调整**：训练过程中，研究人员需要调整一组超参数，如学习率、批量大小和迭代次数等，以确保模型在不同数据集上的可比性和一致性。这些超参数的选择直接影响模型的收敛速度和最终效果<a>[1]</a>。\n\n### 性能评估\n\n训练完成后，模型会在验证集上进行测试，以评估其性能和准确性。PRnet的训练目标是最小化高斯负对数似然损失，这个损失函数用于评估模型的预测结果与实际结果之间的差异。通过这种方式，PRnet能够有效地学习数据中的潜在模式，并优化其参数，以提高预测的准确性<a>[2]</a>。最终，经过验证和调优后，PRnet可以在实际应用中使用，以预测新的扰动响应。\n\n### 应用实例\n\nPRnet在实际应用中表现出色，尤其是在识别针对小细胞肺癌（SCLC）和结直肠癌（CRC）的新型生物活性化合物方面。实验验证显示，针对这些细胞系的新候选化合物在适当的预测浓度范围内表现出活性，这进一步验证了PRnet的有效性和可靠性<a>[7]</a>,<a>[9]</a>。\n\n总之，PRnet的训练过程是一个系统化的流程，依赖于高质量的数据集、深度学习技术和有效的优化算法，以确保模型能够准确地预测系统的响应。",
                    "chat_no": 211,
                    "reference": [
                        {
                            "bbox": [
                                305,
                                69,
                                561,
                                100
                            ],
                            "index": 1,
                            "name": "[1]",
                            "page": 8,
                            "paragraph": "The table below (see Table 1) outlines the values for the hyper- parameters involved in PRnet training. The same set of hyperpara- meters is used across all splits and datasets."
                        },
                        {
                            "bbox": [
                                38,
                                455,
                                295,
                                475
                            ],
                            "index": 2,
                            "name": "[2]",
                            "page": 8,
                            "paragraph": "The training objective of PRnet is to minimize the Gaussian negative log-likelihood loss defined as:"
                        },
                        {
                            "bbox": [
                                38,
                                585,
                                295,
                                616
                            ],
                            "index": 3,
                            "name": "[3]",
                            "page": 8,
                            "paragraph": "To train and test PRnet, all datasets were split into three subsets: train, valid, and test in a ratio of 6:2:2, according to different split strategies. A total of four split strategies were designed:"
                        },
                        {
                            "bbox": [
                                306,
                                358,
                                560,
                                378
                            ],
                            "index": 4,
                            "name": "[4]",
                            "page": 11,
                            "paragraph": "The code for PRnet67 is available at (https://github.com/Perturbation- Response-Prediction/PRnet)."
                        },
                        {
                            "bbox": [
                                306,
                                615,
                                561,
                                742
                            ],
                            "index": 5,
                            "name": "[5]",
                            "page": 1,
                            "paragraph": "PRnet (as detailed in “Methods”) is a flexible and scalable perturbation-conditioned deep generative model designed to predict transcriptional responses to novel complex chemical perturbations at bulk and single-cell levels. The design of PRnet comprises three com- ponents, including the Perturb-adapter, the Perturb-encoder, and the Perturb-decoder (Fig. 1b). In preprocessing, each perturbed profile is assigned an unperturbed transcriptional profile of the same cell line. Initially, given a chemical perturbation imposed by the structure of compounds represented by Simplified Molecular Input Line Entry System3 0 (SMILES) strings and the dosages of the corresponding compounds, PRnet leverages RDKit31 to capture the functional topol- ogy information of the structures, generate the Functional-Class"
                        },
                        {
                            "bbox": [
                                306,
                                47,
                                561,
                                196
                            ],
                            "index": 7,
                            "name": "[7]",
                            "page": 1,
                            "paragraph": "PRnet was trained with close to one hundred million bulk HTS obser- vations perturbed by 175,549 compounds and tens of millions single cell HTS observations perturbed by 188 compounds. Crucially, the model operates as a data-driven model, allowing for effective gen- eralization to novel perturbations. The evaluation indicated that PRnet outperformed alternative approaches in predicting changes and expression in transcription response to novel compounds, pathways, and cell lines in bulk and single-cell HTS data. To further validate the effectiveness, PRnet has been utilized to identify novel bioactive compounds against small cell lung cancer (SCLC) and seek novel nat- ural compounds against colorectal cancer (CRC). Experimental vali- dation demonstrated the activity of novel candidate compounds against SCLC and CRC cell lines within the appropriate predicted ranges of concentration."
                        },
                        {
                            "bbox": [
                                39,
                                583,
                                295,
                                742
                            ],
                            "index": 9,
                            "name": "[9]",
                            "page": 2,
                            "paragraph": "PRnet was trained on two compound libraries and screened four compound libraries (Fig. 1c). The training compound libraries contain a bulk high-throughput screening library consisting of over 883,269 transcriptional profiles of 175,549 bioactive compounds1 , and a single- cell high-throughput screening library consisting of 290,888 tran- scriptional profiles of 188 active compounds2 . Being well trained in HTS observations, PRnet enables in silico high-throughput screening of novel compound libraries for various cell lines. PRnet has further been applied to screen active and drug-like compounds for SCLC and natural compounds for CRC. In vitro validation experiments with MTT assays confirmed the efficacy of the candidate compounds against SCLC and CRC cell lines. Lastly, PRnet screened four compound libraries and generated a large-scale integration atlas of perturbation profiles (Fig. 1d), including (1) 82 cell lines perturbed by 935 FDA- approved drugs, (2) 88 cell lines perturbed by 4158 active compounds, compounds, respectively. For in-silico screening, PRnet initially predicts the aver- age transcriptional profile, fold-change in the gene, and gene rank after perturbing the specific cell line with screening compounds. Given the gene signature for a particular disease or sensitive drug, the enrichment scores of screening com- pounds were computed for compound ranking. In vitro validation experiments were conducted using MTT assays on colorectal cancer and small cell lung cancer cell lines to validate the activity of compound candidates. After in vitro validation, PRnet is utilized to recommend drug candidates for 233 different diseases. d The large-scale integration atlas of perturbation profiles, including the L1000 dataset, the Sci-plex3 dataset, the FDA-approved drugs dataset, the anti-cancer compounds dataset, the natural compounds dataset, the drug-like compounds dataset, and the Gtex dataset. Some icons were created in BioRender. Qi, X. (2024) biorender.com/ l45e810."
                        }
                    ]
                },
                rawText: '这篇文章主要讨论了一个名为PRnet的深度学习模型，旨在通过预测化学干扰对基因表达的影响，为药物发现提供支持。文章首先介绍了PRnet的设计和功能，强调其在传统药物筛选方法中存在的局限性，如耗时和高成本，以及新疗法发现的低成功率。PRnet通过结合大量的高通量筛选（HTS）数据和单细胞HTS观察结果，能够有效预测未见化学干扰的转录反应，从而为新化合物的筛选提供了新的思路和工具（snippet_3, snippet_7）。\\n\\n具体而言，PRnet采用了编码器-解码器结构进行反事实预测，利用接近一亿个HTS观察结果和175,549种化合物的扰动数据进行训练。这使得PRnet在预测新化合物的转录响应和表达变化方面表现优于其他现有方法。文章指出，尽管已有一些工具能够模拟化学扰动，但它们在处理新化合物时的能力有限，而PRnet的灵活性和可扩展性使其成为药物筛选的有价值工具（snippet_7）。\\n\\n此外，文章还详细描述了PRnet在药物候选推荐方面的应用。通过生成覆盖88个细胞系和52种组织的大型扰动特征图谱，PRnet成功推荐了577个药物候选者，涵盖233种不同的疾病。这些推荐是基于共同的基因表达特征，类似于连接基因、药物和疾病的概念。文章特别强调了PRnet在非酒精性脂肪肝病、卵巢多囊综合症和炎症性肠病等代谢疾病中的应用潜力（snippet_9）。\\n\\n在方法论方面，文章介绍了基于基因表达数据的药物筛选和预测模型的构建过程。通过计算确定性系数（R\xb2）来评估不同化合物对基因表达的影响，文章还利用t-SNE嵌入法表示不同剂量下细胞的基因表达情况，从而帮助理解不同剂量对基因表达的影响。这一过程为复杂疾病的候选药物筛选提供了有力的支持（snippet_8）。此外，文章还讨论了如何将标志基因的转录组特征转化为更大规模的基因特征，通过计算每个化合物在不同细胞系中的平均折叠变化，进一步形成基因表达签名（snippet_8）。\\n\\n总的来说，PRnet被认为是基于基因的治疗筛选的有效工具，能够为药物发现和疾病治疗提供广泛的应用前景。文章强调了化学干扰的转录反应如何揭示生物功能的基本见解，并在疾病理解和药物发现中发挥重要作用（snippet_3, snippet_9）。通过深入分析和建模，PRnet展示了其在推动药物发现和生物医学研究领域的潜力。',
                highlightedHtml: '这是一个测试文本，其中包含**重要**的关键词。',
                isPhone,
                copyText: '',
                test: {
                    "content": "Hypothyroidism can primarily be categorized into different types based on the underlying causes:\n\n1. It can result from a deficiency in thyroid hormones production, which might occur due to autoimmune diseases like Hashimoto's thyroiditis, where the immune system attacks the thyroid gland.\n2. Certain medications or medical treatments such as radioactive iodine therapy or thyroid surgery can also lead to hypothyroidism by impairing the thyroid gland\u2019s ability to produce hormones.[1][2]\n\nThese causes affect the thyroid gland's ability to produce sufficient thyroid hormones, leading to the various symptoms associated with hypothyroidism.",
                },
                inputValue: '',
                prefix1: this.promptPrefix,
                radioValue: this.initRadioValue,
                selectValue: this.initSelectValue,
                model: 'gpt-3.5-turbo',
                width: '',
                textItems: [],
                group: 0,
                wrapperHeight: isPhone? 20: 32,
                waiting: false,
                disabled: false,
                loadingChatMsg: false,
                imgInfo: {},
                chat_no: 0
            }
        },
        watch:{

        },
        created(){

        },
        mounted(){

        },
        methods:{
            formatTime,
            get_ref_color,

            handleClick(event){
                console.log(event);
                if (event.target.classList.contains('highlight')) { // 确保是我们要处理的元素
                    alert('关键词被点击！');
                }
            },
            sendEg(item){
                let {waiting, radioKey} = this;
                if(waiting) return;
                this.prefix1 = item.prefix;
                this.imgInfo = item;
                this[radioKey] = item[radioKey];
                this.handleSubmit(item.text);
            },

            handleSubmit(value){
                let { textItems, imgInfo, group, tag, prefix1, chat_no, paper_no} = this;
                imgInfo = imgInfo || {};
                textItems = textItems || [];
                let {src} = imgInfo;
                prefix1 = prefix1 || '';
                let question = (prefix1) + value;
                textItems = [
                    ...textItems,
                    {
                        className: 'textRight',
                        text: question,
                        question,
                        answer: '',
                        think: '',
                        src,
                        group,
                        tag
                    }
                ];
                this.wrapperHeight = this.isPhone ? 70: 64;

                this.inputValue = '';
                this.value = value;
                this.waiting = true;
                this.textItems = textItems;
                this.scrollToBottom();
                // let stream = true;
                let rq = {msg: value, paper_no};
                if(chat_no) rq.chat_no = chat_no;
                if(this.embedding === -2) {
                    this.renderAnswer(value, '上传失败!PDF文件太大，请拆分后上传。此次提问不消耗积分');
                    this.disabled = false;
                }
                else if(this.embedding < 0) {
                    this.renderAnswer(value, '解析失败，请联系管理员。此次提问不消耗积分');
                    this.disabled = false;
                }
                else if(this.embedding < 2) {
                    this.renderAnswer(value, '未解析完成，请稍后再试。此次提问不消耗积分');
                    this.disabled = false;
                }
                else post_biogpt_chat_message(rq, (data)=>{
                    // let {content, tag} = data;
                    // let {data, message, status} = res;
                    let message = '';
                    console.log('postFunc', data);
                    let answer = '';
                    this.chat_no = data?.chat_no;
                    let tag = data?.type;
                    // tag === 'reference',
                    let ref_list =  data?.reference || [];
                    if(tag === 'reference') ref_list = [data];
                    if(tag === 'think') answer = data?.think || answer;
                    if(tag === 'token') answer = data?.token || answer;
                    if(status === 1210001) message = '积分不足，请联系管理员；此外，上传和分享可以帮您获取积分。';
                    console.log(tag, answer);
                    this.renderAnswer(value, answer || message || '', 0, ref_list, undefined, tag);
                    this.disabled = false;
                    if(this.setHeight) this.setHeight();
                });

            },
            renderAnswer(question, res_message, n=0, refs, ref, tag){
                let {textItems, group} = this;
                textItems = textItems || [];
                let lastIndex = textItems.length - 1;
                let lastItem = textItems[lastIndex];
                let endSign = '[DONE]';
                let isThink = tag === 'think';
                if(res_message.endsWith(endSign)) {
                    console.log(endSign, res_message);
                    res_message = res_message.substring(0, res_message.length - endSign.length);
                    this.disabled = false;
                } else this.disabled = true;
                lastItem.tag = tag;
                lastItem.isThink = isThink;
                if(isThink) lastItem.think += res_message;
                else lastItem.answer += res_message;
                let {ref_list} = lastItem;
                ref_list = ref_list || [];
                if(Array.isArray(refs )) ref_list = [...ref_list, ...refs];
                if(ref?.book) ref_list = [...ref_list, ref];
                lastItem.ref_list = [...ref_list];
                textItems[lastIndex] = lastItem;
                this.waiting = false;
                this.textItems = textItems;
                this.group = group + 1;
                if(n === 0) this.scrollToBottom();
            },
            async copyAnswer(item){
                let {answer, ref_list} = item;
                let copyArr = [answer];
                ref_list = ref_list || [];
                ref_list.map((ref, index)=>{
                    copyArr = [...copyArr, '[' + (ref?.ref_id || (index + 1)) + '].' + (ref.Title || ref.book || ref.url)];
                });
                console.log(copyArr);
                this.copyText = copyArr.join('\n');
                copyInputValue('.copy');
                // let
            },
            showRefDetail(index, rIndex){
                let {textItems} = this;
                textItems = textItems || [];
                let {ref_list} = textItems[index];
                let ref = ref_list[rIndex];
                ref.showText = !ref.showText;
                textItems[index].ref_list[rIndex] = ref;
                this.textItems = textItems;
            },
            scrollToBottom(){
                try{
                    // this.messagesEndRef.current.scrollIntoView({behavior: 'smooth'});
                    document.getElementById('bottom').scrollIntoView();
                    // ({behavior: 'smooth'})
                }
                catch (e) {
                    var element = document.getElementById('dialogue'); // 获取需要滚动的元素
                    if(element === null) return;
                    element.scrollTop = element.scrollHeight;
                }
            },
            deleteTextItems(){
                this.textItems = [];
            },
            changePrefix(e){
                let {radioKey, radioItems} = this;
                let {value} = e.target;
                if(radioKey && Array.isArray(radioItems)){
                    let {label} = radioItems.find(r=>r.value === value);
                    this['prefix1'] = label + '：';
                }
                else this['prefix1'] = value;
                if(radioKey) this[radioKey] = value;
            },
            getContainer() {
                return document.getElementById('dialogue');
            },
        }
    }
</script>

<style scoped>

    #dialogue{
        padding: 0 5px;
        /*!*1.30尝试*!*/
        overflow: hidden;
        position: relative;
    }
    #dialogue li{
        margin-bottom: 5px;
        position: relative;
        border-radius: 7px;
        /*background-color: #a6e860;*/
        text-align: left;
        z-index: 1;
        line-height: 1.5rem;
        /*1.30尝试*/
        /*position: absolute;*/
        /*overflow-y: hidden;*/
        /*animation: scroll-up 5s linear infinite;*/
    }
    .msg-content{
        width: 95%;
    }
    .think{
        border-left: 4px solid #eee;
        color: #8b8b8b;
        padding-left: 10px;
        font-size: 16px!important;
        text-align: justify;
        width: 95%;
        margin-bottom: 12px
    }
    .icon {
        vertical-align: top;
        font-size: 18px;
        margin-top: 8px;
        margin-right: 3px
    }
    .icon-right{
        color: rgb(113,145,254);
        float: right;
        margin-left: 3px;
    }
    #dialogue .answer-box, #dialogue .text-right{
        padding: 10px;
        border-radius: 10px;
        /*box-shadow: 10px 20px 5px rgba(0,0,0,0.3);*/
    }
    #dialogue .answer-box{
        /*border: 1px solid #F2F2F2;*/
        /*box-shadow: 10px 20px 5px rgba(0,0,0,0.3);*/
    }
    #dialogue .text-right{
        background: rgb(113,145,254);
        color: #fff;
        float: right;
        margin: 10px 0;
    }
    @keyframes scroll-up {
        0% {
            transform: translateY(100%);
        }
        100% {
            transform: translateY(-100%);
        }
    }


    @media screen and (max-width: 765px) {
        #dialogue li {
            line-height: 1.35rem;
            font-size: 0.95rem!important;
        }
    }





    /*客服对话框底部与输入*/
    .dialogue-submit {
        padding: 5px 0 0;
        /*height: 100px;*/
        color: #000;
        word-wrap: break-word;
        /*border-top: 1px solid #ddd;*/
    }



    @keyframes write {
        0% {
            width: 0;
        }

        100% {
            width: 100%;
        }
    }

    @keyframes blink {
        50% {
            /* transparent是全透明黑色(black)的速记法，即一个类似rgba(0,0,0,0)这样的值。 */
            border-color: transparent; /* #00000000 */
        }
    }


    /* 隐藏滚动条 */
    ::-webkit-scrollbar {
        width: 0; /* 设置滚动条宽度 */
    }

    /* 滚动条轨道 */
    ::-webkit-scrollbar-track {
        background-color: #f1f1f1; /* 设置滚动条轨道背景颜色 */
    }

    /* 滚动条滑块 */
    ::-webkit-scrollbar-thumb {
        background-color: #999; /* 设置滚动条滑块颜色 */
    }

    /* 滚动条滑块悬停状态 */
    ::-webkit-scrollbar-thumb:hover {
        background-color: #555; /* 设置滚动条滑块悬停状态颜色 */
    }
</style>
